import React, { useEffect, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { t, currentLanguage, safeValue, isPhoneValid, isVatValid, isEmailValid, RECAPTCHA_SITE_KEY } from '../utils'
import { updateUserData } from '../services/database'
import { getCompanyData } from '../services/functions'
import { animateScroll as scroll } from 'react-scroll'
import config from '../config.json'
import { Loader } from './'

const APStepProfile = ({
  onSave,
  refreshInteractions,
  showSnackbar,
  startLoading,
  stopLoading,
  fetchUserData,
  userDataFetched,
  dataSharingOptIn,
  setDataSharingOptIn,
  userData
}) => {

  // const { onSave, history, refreshInteractions, showSnackbar, startLoading, stopLoading, fetchUserData, userDataFetched } = props

  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [addressStreet, setAddressStreet] = useState('')
  const [addressNumber, setAddressNumber] = useState('')
  const [addressCity, setAddressCity] = useState('')
  const [addressZip, setAddressZip] = useState('')
  const [organisation, setOrganisation] = useState('')
  const [vat, setVat] = useState('')
  const [captchaValue, setCaptchaValue] = useState(null)

  useEffect(() => {
    refreshInteractions()
  }, [])


  useEffect(() => {
    setFirstName(safeValue(userData, 'name.first'))
    setLastName(safeValue(userData, 'name.last'))
    setEmail(safeValue(userData, 'contact.email'))
    setPhone(safeValue(userData, 'contact.phone'))
    setAddressStreet(safeValue(userData, 'address.street'))
    setAddressNumber(safeValue(userData, 'address.number'))
    setAddressCity(safeValue(userData, 'address.city'))
    setAddressZip(safeValue(userData, 'address.zip'))
    setVat(safeValue(userData, 'vat'))
    setOrganisation(safeValue(userData, 'organisation'))
    refreshInteractions()
  }, [userData])

  const saveChanges = async () => {
    setTimeout(() => {
      scroll.scrollTo(350)
    }, 1);
    if (!isDataComplete()) {
      showSnackbar({ text: t('account.data_incomplete'), color: 'error' })
      return
    }
    if(!captchaValue) {
      showSnackbar({ text: t('auth.captcha'), color: 'error' })
      return 
    }
    startLoading('updatingUser')
    let result = await updateUserData({
      name: {
        first: firstName,
        last: lastName
      },
      contact: {
        phone: phone,
        email: email
      },
      address: {
        street: addressStreet,
        number: addressNumber,
        city: addressCity,
        zip: addressZip
      },
      organisation: organisation,
      vat: vat,
      dataSharingOptIn: dataSharingOptIn,
    })
    if (result.error) {
      showSnackbar({ text: result.error.message, color: 'error' })
    } else {
      if (config.partner === 'axa') {
        const axaClientData = await getCompanyData(vat, (err) => {
          console.log(err);
        });
        // console.log("axa client data", axaClientData)
        onSave(axaClientData.contractExists && axaClientData.eligible);
      } else {
        onSave()
      }
      fetchUserData()
    }
    stopLoading('updatingUser')
  }

  const isDataComplete = () => {
    if (!phone || !isPhoneValid(phone)) {
      return false
    }
    else if (!email || !isEmailValid(email)) {
      return false
    }
    if (!lastName) {
      return false
    }
    if (!firstName) {
      return false
    }
    if(config.partner === 'axa') {
      if (!addressCity) {
          return false
        }
      if (!addressStreet) {
        return false
      }
      if (!addressNumber) {
        return false
      }
      if (!addressZip) {
        return false
      }
      if (!organisation) {
        return false
      }
      if (!vat || !isVatValid(vat)) {
        return false
      }
    }
    return true
  }

  const fieldLabel = (title, required) => {
    return `${title}${required ? ' *' : ''}`
  }

  const renderHint = () => {
    switch (config.partner) {
      case 'lv':
        return (<span className="field-hint">{t('appointment.org_hint')}</span>)
      case 'axa':
        return null
      default:
        return null
    }
  }

  const fieldRequired = () => {
    switch (config.partner) {
      case 'lv': 
        return false
      case 'axa':
        return true
      default: 
        return false
    }
  }

  return (
    <div className="container">
      <div className="container container--hero small">
        <h3 data-w-id="0e48b1ac-9288-3d3d-ae7b-164a2f0f8aa4" /* style="opacity:0" */ className="h3 h3--bold h3--blue"> {`${t('appointment.profile_info_title')}`}<br /></h3>
        {!userDataFetched && (
          <div className="profile-loader-wrapper">
            <Loader primary normal small />
          </div>
        )}
        {userDataFetched && (
          <div className="form w-form apstep-profile-wrapper">
            <h4 className="form__title form__title--mt">{t('appointment.contact_info')}</h4>
            <div className="field-wrap">
              <div className={`form__field-wrap form__field-wrap--ml ${!lastName ? 'invalid' : ''}`}>
                <label className="form__label">{fieldLabel(t('general.name_last'), true)}</label>
                <span className="field-hint">&nbsp;</span>
                <input value={lastName} onChange={e => setLastName(e.target.value)} type="text" className="form__text-field w-input" maxLength="256" name="Email" data-name="Email" id="Email-4" required="" />
              </div>
              <div className={`form__field-wrap form__field-wrap--ml ${!firstName ? 'invalid' : ''}`}>
                <label className="form__label">{fieldLabel(t('general.name_first'), true)}</label>
                <span className="field-hint">&nbsp;</span>
                <input value={firstName} onChange={e => setFirstName(e.target.value)} type="text" className="form__text-field w-input" maxLength="256" name="Email" data-name="Email" id="Email-4" required="" />
              </div>
            </div>
            <div className="field-wrap">
              <div className={`form__field-wrap ${!isPhoneValid(phone) ? 'invalid' : ''}`}>
                <label htmlFor="N-de-t-l-phone" className="form__label">{fieldLabel(t('profile.phone'), true)}</label>
                <span className="field-hint">{t('appointment.phone_hint')}</span>
                <div className="input-with-adornment-wrapper">
                  <div className="form__text-field w-input input-adornment">{'+32'}</div>
                  <input value={phone} onChange={e => setPhone(e.target.value)} type="text" className="form__text-field w-input" maxLength="256" name="N-de-t-l-phone" data-name="N° de téléphone" id="N-de-t-l-phone" required="" />
                </div>
              </div>
              <div className={`form__field-wrap form__field-wrap--ml ${!isEmailValid(email) ? 'invalid' : ''}`}>
                <label htmlFor="Email-4" className="form__label">{fieldLabel(t('general.email'), true)}</label>
                <span className="field-hint">&nbsp;</span>
                <input value={email} onChange={e => setEmail(e.target.value)} type="email" className="form__text-field w-input" maxLength="256" name="Email" data-name="Email" id="Email-4" required="" />
              </div>
            </div>
            <h4 className="form__title form__title--mt">{t('profile.organisation')}</h4>
            {renderHint()}
            <div className="form__field-wrap width">
              <label htmlFor="Title-5" className="form__label">{fieldLabel(t('profile.organisation_name'), fieldRequired())}</label>
              <input value={organisation} onChange={e => setOrganisation(e.target.value)} type="text" className="form__text-field w-input" maxLength="256" name="Title-4" data-name="Title 4" id="Title-4" required="" />
            </div>
            <div className="field-wrap">
              <div className="form__field-wrap">
                <label htmlFor="Adresse" className="form__label">{fieldLabel(t('profile.street'), fieldRequired())}</label>
                <input value={addressStreet} onChange={e => setAddressStreet(e.target.value)} type="text" className="form__text-field w-input" maxLength="256" name="Adresse" data-name="Adresse" id="Adresse" required="" />
              </div>
              <div className="form__field-wrap form__field-wrap--sm">
                <label htmlFor="Prenom-2" className="form__label">{fieldLabel(t('profile.number'), fieldRequired())}</label>
                <input value={addressNumber} onChange={e => setAddressNumber(e.target.value)} type="text" className="form__text-field w-input" maxLength="256" name="Prenom-2" data-name="Prenom 2" id="Prenom-2" required="" />
              </div>
            </div>
            <div className="field-wrap">
              <div className="form__field-wrap">
                <label htmlFor="Adresse-2" className="form__label">{fieldLabel(t('profile.city'), fieldRequired())}</label>
                <input value={addressCity} onChange={e => setAddressCity(e.target.value)} type="text" className="form__text-field w-input" maxLength="256" name="Adresse-2" data-name="Adresse 2" id="Adresse-2" required="" />
              </div>
              <div className="form__field-wrap form__field-wrap--sm">
                <label htmlFor="Prenom-3" className="form__label">{fieldLabel(t('profile.zip'), fieldRequired())}</label>
                <input value={addressZip} onChange={e => setAddressZip(e.target.value)} type="text" className="form__text-field w-input" maxLength="256" name="Prenom-2" data-name="Prenom 2" id="Prenom-2" required="" />
              </div>
            </div>
            <div className={`form__field-wrap width`}>
              <label htmlFor="N-de-TVA" className="form__label">{fieldLabel(t('profile.vat'), fieldRequired())}</label>
              <div className="input-with-adornment-wrapper">
                <div className="form__text-field w-input input-adornment">{t('profile.vat_prefix')}</div>
                <input value={vat} onChange={e => setVat(e.target.value)} type="text" className="form__text-field w-input" maxLength="10" name="N-de-TVA" data-name="N° de TVA" id="N-de-TVA" required="" />
              </div>
            </div>
            {/* Data sharing opt-in */}
            <div className="form__field-wrap form__checkbox-wrap form__field-wrap--row form__field-wrap--stretch">
              <input type="checkbox" id="checkbox-2" name="checkbox-2" className="form__checkbox w-checkbox-input" checked={dataSharingOptIn} onChange={e => setDataSharingOptIn(e.target.checked)} />
              <label htmlFor="checkbox-2" className="form__checkbox-label w-checkbox-label">
                <span className="optin-checkbox-label">
                  {t('appointment.data_sharing_optin1')}&nbsp;
                  <a href="/" className="link" target="_blank" rel="noopener noreferrer">{t('appointment.data_sharing_optin_link')}</a>&nbsp;
                  {t('appointment.data_sharing_optin2')}
                </span>
              </label>
            </div>
          </div>
        )}
      </div>
      {userDataFetched && <ReCAPTCHA
        sitekey={RECAPTCHA_SITE_KEY}
        onChange={(val) => setCaptchaValue(val)}
        hl={currentLanguage()}
      />}
      <div className="form__btn-wrap">
        {userDataFetched && <div onClick={saveChanges} className="link-box link-box--submit w-inline-block link-box--green profile_save_button">
          <p className="link-box__title">{t('general.save')}<br /></p>
        </div>}
      </div>
    </div>
  )
}

export default APStepProfile